import { RootState } from 'store';
import { ICategoriesDetails, ICategoriesResponse } from 'types';

export const getCategoriesSelector = (store: RootState): ICategoriesResponse | null => store.categories.data || null;

export const getUpdateRowSelector = (store: RootState): ICategoriesDetails | null => store.categories.updateRow || null;

export const getCategoriesIsLoadingSelector = (store: RootState): boolean => store.categories.isLoading;
